import * as React from 'react';
import { Box } from '~shared/components/Box';
import { UseIconProps, useIcon } from '../../useIcon';
import { IconResultsGridPencilSvg } from './IconResultsGridPencilSvg';

export type IconResultsGridPencilProps = UseIconProps;

export function IconResultsGridPencil(props: IconResultsGridPencilProps) {
  const iconProps = useIcon({ size: 'micro', ...props });
  return <Box tagName={IconResultsGridPencilSvg} {...iconProps} />;
}
